import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import React from 'react'
import { WebinarCallToActionEntityInterface } from 'src/shared/entities/webinar-call-to-action/webinar-call-to-action-entity.schema'
import createCommonEntitySettings from '../createCommonEntitySettings'
import WebinarCallToActionSettings from './settings/WebinarCallToActionSettingsNew'
import WebinarSessionVideoSettingsNew from './settings/WebinarSessionVideoSettingsNew'

function createSettingsForWebinarSession(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.WebinarSessionVideo:
      return (
        <WebinarSessionVideoSettingsNew
          entity={entity as VideoInterface}
          defaultEntity={defaultEntity as VideoInterface}
        />
      )
    case EntityTypeEnum.WebinarCallToAction:
      return (
        <WebinarCallToActionSettings
          entity={entity as WebinarCallToActionEntityInterface}
          defaultEntity={defaultEntity as WebinarCallToActionEntityInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForWebinarSession
